import { render, staticRenderFns } from "./EditSchool.vue?vue&type=template&id=a5b220fa"
import script from "../../services/school/edit-school.js?vue&type=script&lang=js&external"
export * from "../../services/school/edit-school.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/teacher/edit-teacher.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports